import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import SitecoreLink from 'Foundation/GlassMapper/SitecoreLink';
import { useUserData } from 'Foundation/User/UserContext';
import { FunctionComponent, useEffect, useState } from 'react';
import { populateTokens } from 'Utilities/URLHelper';

const LinkSection: FunctionComponent<ILinkSection> = (props: ILinkSection) => {
  const [navLinks, setNavLinks] = useState<INavigationLink[]>([]);
  const [filteredNavLinks, setFilteredNavLinks] = useState<INavigationLink[]>([]);
  const { userData } = useUserData();

  useEffect(() => {
    if (userData)
      setFilteredNavLinks(
        navLinks.filter((x) => {
          let hasState: boolean = x.IncludedStates.includes(userData.state);
          if (props?.filterTerm) {
            let matchesLink: boolean = x.Link?.Text?.toLowerCase().includes(props.filterTerm?.toLowerCase()) ?? false;
            let matchesSubText: boolean =
              x.Link?.SubText?.toLowerCase().includes(props.filterTerm?.toLowerCase()) ?? false;
            let matchesHeading: boolean = props.Title?.toLowerCase().includes(props.filterTerm) ?? false;
            let matchesSectionSubText: boolean = props.SubText?.toLowerCase().includes(props.filterTerm) ?? false;
            return hasState && (matchesSectionSubText || matchesHeading || matchesLink || matchesSubText);
          } else return hasState;
        }),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navLinks, userData?.state, props?.filterTerm]);

  useEffect(() => {
    if (props && props.Links && userData) {
      setNavLinks(populateTokens(props.Links, userData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, userData?.selectedStatCodeData.SubStat, userData?.state]);

  useEffect(() => {
    if (filteredNavLinks && filteredNavLinks.length === 0 && props.filterTerm && props.filterTerm.length > 0)
      props.showHideAccordion(false);
    else if (filteredNavLinks) props.showHideAccordion(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredNavLinks]);

  return (
    <>
      {filteredNavLinks && filteredNavLinks.length > 0 && (
        <>
          {props.SubText && (
            <div className="nav-section-rich-text-top">
              <RichText content={props.SubText} />
            </div>
          )}
          <div className="navigation-section">
            <div className="menu-section-links">
              {filteredNavLinks &&
                filteredNavLinks.length > 0 &&
                filteredNavLinks.map(
                  (link: INavigationLink) =>
                    link.Link && (
                      <>
                        <div className="menu-section-link">
                          <SitecoreLink
                            Class={link.Link.Class}
                            Goal={link.Link.Goal}
                            key={link.Link.Text}
                            Target={link.Link.Target}
                            Text={link.Link.Text}
                            SubText={link.Link.SubText}
                            Url={link.Link.Url}
                            TargetId={link.Link.TargetId}
                            Favoritable={props.Favoritable}
                            CaretPosition={'none'}
                            OnClick={link.OnClick}
                            IsKeyContactLink={link.Link.IsKeyContactLink}
                          />
                          {link.Link.SubText && !link.Link.IsKeyContactLink && (
                            <p
                              className="menu-section-link-subtext"
                              dangerouslySetInnerHTML={{ __html: link.Link.SubText }}
                            ></p>
                          )}
                        </div>
                      </>
                    ),
                )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LinkSection;
